import getConfig from 'next/config';
import NextScript from 'next/script';

export function GoogleTagManagerScript() {
  const { googleTagManagerToken } = getConfig().publicRuntimeConfig;
  if (!googleTagManagerToken) return null;
  const snippet = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.defer=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${googleTagManagerToken}');`;
  return (
    <NextScript
      id='GTM_SCRIPT'
      dangerouslySetInnerHTML={{ __html: snippet }}
      strategy='afterInteractive'
    />
  );
}
